import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ITServices from "../pages/it-services/page";
import ConsultancyServices from "../pages/consultancy-services/page";
import StrategicBusinessAdvisory from "../pages/strategic-business-advisory/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/it-services",
    element: <ITServices />,
  },
  {
    path: "/consultancy-services",
    element: <ConsultancyServices />,
  },
  {
    path: "/strategic-business-advisory",
    element: <StrategicBusinessAdvisory />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
